import React from 'react';
import { CheckOutlined } from '@ant-design/icons';

import { OptionItem } from '../../types';
import { optionsNum } from '../../constant';

import './index.less';

interface IProps {
  firstIndex: number;
  secondIndex: number;
  options: OptionItem[];
  myAnswer: string | string[];
  singleClick: (firstIndex: number, secondIndex: number, options: OptionItem[]) => void;
}

function SingleOption({ firstIndex, secondIndex, myAnswer, options, singleClick }: IProps) {

  function clickOption(index: number): void {
    let newOptions: OptionItem[] = [...options];
    newOptions.map((item, _index) => {
      if (_index === index) {
        item.tag = 1;
        return item;
      }
      item.tag = 0;
      return item;
    })
    singleClick(firstIndex, secondIndex, newOptions);
  }
  

  return (
    <ul className="test-single-option">
      {
        options.map((item, index) => {
          return (
          <li className={myAnswer.indexOf(item.id) >= 0 ? 'active' : ''} key={item.id} onClick={() => clickOption(index)}>
            <div className="icon"><CheckOutlined /></div>
            <div>{optionsNum[index]}、</div>
            <div>{item.option}</div>
          </li>)
        })
      }
    </ul>
  )
}

export default SingleOption;
